import React, { useEffect, useMemo } from 'react'
import { useDispatch, useSelector } from 'react-redux';
import { store_minimum_delivery_fees_type } from '../constant/constant';
const useMinimumOrderFees = () => {
    const selectedStore = useSelector((state: any) => state?.store?.selectedStore)

    const minOrderDeliveryPrice = useSelector((state: any) => state?.cartData.minOrderDeliveryPrice);
    const returnStoreRadiousMinimumFees = useMemo(() => {
        let isRadious = process.env.REACT_APP_MINIMUMORDERFEES_TYPE == store_minimum_delivery_fees_type.radios;
        let fees = isRadious ? selectedStore?.store_delivery_radius : selectedStore?.map_store_delivery_areas;

        return minOrderDeliveryPrice ? minOrderDeliveryPrice : fees?.length > 0 ? fees[0].minimum_order_fees : 0
    }, [selectedStore, minOrderDeliveryPrice]);

    return { returnStoreRadiousMinimumFees }
}
export default useMinimumOrderFees